"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const deleteIncomingOrderById_1 = __importDefault(require("./deleteIncomingOrderById"));
const getNextIncomingOrderNumber_1 = __importDefault(require("./getNextIncomingOrderNumber"));
const getIncomingOrderById_1 = __importDefault(require("./getIncomingOrderById"));
const postIncomingOrder_1 = __importDefault(require("./postIncomingOrder"));
const postIncomingOrderMatchQuery_1 = __importDefault(require("./postIncomingOrderMatchQuery"));
const postIncomingOrderFindJourneysByIds_1 = __importDefault(require("./postIncomingOrderFindJourneysByIds"));
const putIncomingOrderById_1 = __importDefault(require("./putIncomingOrderById"));
// import deleteIncomingOrderCommentary from "./deleteIncomingOrderCommentary";
// import getIncomingOrderActivity from "./getIncomingOrderActivity";
// import getIncomingOrderDuplicate from "./getIncomingOrderDuplicate";
// import postIncomingOrderCommentary from "./postIncomingOrderCommentary";
// import postIncomingOrderMatchQuery from "./postIncomingOrderMatchQuery";
// import postIncomingOrderPayment from "./postIncomingOrderPayment";
// import postIncomingOrderBoardMatchQuery from "./postIncomingOrderBoardMatchQuery";
// import postIncomingOrderWaypointDriveThrough
//   from "./postIncomingOrderWaypointDriveThrough";
// import deleteIncomingOrderWaypointDriveThrough
//   from "./deleteIncomingOrderWaypointDriveThrough";
// import putIncomingOrderWaypointDriveThrough
//   from "./putIncomingOrderWaypointDriveThrough";
// import putIncomingOrderCommentary from "./putIncomingOrderCommentary";
const createIncomingOrderClient = (axios) => ({
    deleteIncomingOrderById: ({ incomingOrderId }) => deleteIncomingOrderById_1.default({
        axios,
        incomingOrderId
    }),
    getNextIncomingOrderNumber: () => getNextIncomingOrderNumber_1.default({ axios }),
    getIncomingOrderById: ({ incomingOrderId }) => getIncomingOrderById_1.default({
        axios,
        incomingOrderId
    }),
    postIncomingOrder: ({ incomingOrder }) => postIncomingOrder_1.default({ axios, incomingOrder }),
    postIncomingOrderMatchQuery: ({ query }) => postIncomingOrderMatchQuery_1.default({ axios, query }),
    postIncomingOrderFindJourneysByIds: ({ incomingOrderIds }) => postIncomingOrderFindJourneysByIds_1.default({ axios, incomingOrderIds }),
    putIncomingOrderById: ({ incomingOrderId, incomingOrder }) => putIncomingOrderById_1.default({ axios, incomingOrderId, incomingOrder })
    // deleteIncomingOrderCommentary: ({
    //   incomingOrderId,
    //   commentaryId
    // }: {
    //   incomingOrderId: number,
    //   commentaryId: number
    // }) => deleteIncomingOrderCommentary({
    //   axios,
    //   incomingOrderId,
    //   commentaryId
    // }),
    //
    //
    // getIncomingOrderActivity: ({ incomingOrderId }: { incomingOrderId: number }) => (
    //   getIncomingOrderActivity({ axios, incomingOrderId })
    // ),
    //
    // getIncomingOrderDuplicate: ({
    //   orderSerialNumber
    // }: {
    //   orderSerialNumber: string
    // }) => (
    //   getIncomingOrderDuplicate({ axios, orderSerialNumber })
    // ),
    //
    // postIncomingOrderCommentary: ({
    //   incomingOrderId,
    //   commentary
    // }: {
    //   incomingOrderId: number,
    //   commentary: CommentaryForm
    // }) => postIncomingOrderCommentary({ axios, incomingOrderId, commentary }),
    //
    // postIncomingOrderMatchQuery: ({
    //   query
    // }: {
    //   query: IncomingOrderMatchQuery
    // }) => postIncomingOrderMatchQuery({ axios, query }),
    //
    // postIncomingOrderBoardMatchQuery: ({
    //   query
    // }: {
    //   query: IncomingOrderBoardMatchQuery
    // }) => postIncomingOrderBoardMatchQuery({ axios, query }),
    //
    // postIncomingOrderPayment: ({
    //   incomingOrderId,
    //   payment
    // }: {
    //   incomingOrderId: number,
    //   payment: IncomingOrderPaymentForm
    // }) => postIncomingOrderPayment({ axios, incomingOrderId, payment }),
    //
    // postIncomingOrderWaypointDriveThrough: ({
    //   incomingOrderId,
    //   waypointId
    // }: {
    //   incomingOrderId: number,
    //   waypointId: number
    // }) => postIncomingOrderWaypointDriveThrough({
    //   axios,
    //   incomingOrderId,
    //   waypointId
    // }),
    //
    // putIncomingOrderCommentary: ({
    //   incomingOrderId,
    //   commentaryId,
    //   commentary
    // }: {
    //   incomingOrderId: number,
    //   commentaryId: number,
    //   commentary: CommentaryForm
    // }) => putIncomingOrderCommentary({
    //   axios,
    //   incomingOrderId,
    //   commentaryId,
    //   commentary
    // }),
    //
    // deleteIncomingOrderWaypointDriveThrough: ({
    //   incomingOrderId,
    //   waypointId
    // }: {
    //   incomingOrderId: number,
    //   waypointId: number
    // }) => deleteIncomingOrderWaypointDriveThrough({
    //   axios,
    //   incomingOrderId,
    //   waypointId
    // }),
    //
    // putIncomingOrderWaypointDriveThrough: ({
    //   incomingOrderId,
    //   waypointId,
    //   drivenThroughAt
    // }: {
    //   incomingOrderId: number,
    //   waypointId: number,
    //   drivenThroughAt: Date
    // }) => putIncomingOrderWaypointDriveThrough({
    //   axios,
    //   incomingOrderId,
    //   waypointId,
    //   drivenThroughAt
    // })
});
exports.default = createIncomingOrderClient;
